var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-status-switcher" },
    _vm._l(_vm.statusList, function (status, index) {
      return _c(
        "div",
        {
          key: index,
          class: [
            "status-box",
            {
              active: index <= _vm.currentStatusIndex,
              highlight: index <= _vm.hoverIndex && _vm.hoverIndex !== -1,
            },
          ],
          on: {
            click: function ($event) {
              return _vm.updateStatus(index)
            },
            mouseover: function ($event) {
              return _vm.setHoverIndex(index)
            },
            mouseleave: _vm.resetHoverIndex,
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s("" + (status.label || status.title)) +
              "\n    "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }